import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="inactive-overlay"
export default class extends Controller {
  connect() {
    this.boundShow = this.show.bind(this);
    this.boundHide = this.hide.bind(this);
    this.element.addEventListener("mouseenter", this.boundShow);
    this.element.addEventListener("mouseleave", this.boundHide);
  }

  show() {
    const overlay = this.element.querySelector(".inactive-overlay");
    if (overlay) {
      overlay.classList.remove("hidden");
    }
  }

  hide() {
    const overlay = this.element.querySelector(".inactive-overlay");
    if (overlay) {
      overlay.classList.add("hidden");
    }
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.boundShow);
    this.element.removeEventListener("mouseleave", this.boundHide);
  }
}
